import React, { useContext, useState } from 'react';
import { Row, Col, Card } from 'antd';
import { withRouter, Redirect } from 'react-router-dom';

import StudentImage from '../assets/images/student.png';
import TeacherImage from '../assets/images/teacher.png';

import { StoreContext } from '../containers/Store';
import * as ROLES from '../constants/roles';
import * as ROUTES from '../constants/routes';

const { Meta } = Card;

const Splash = ({ history }) => {
  const { 
    user: { user: authUser, storeUser },
  } = useContext(StoreContext);


  const [visible, show] = useState((!authUser || authUser && authUser.roles.length === 1));
  
  const clickStudent = () => {
    authUser.roles = [ROLES.ADMIN_DEMO, ROLES.STUDENT_DEMO];
    authUser.token = "token-harry-potter";
    storeUser({...authUser});
    history.push(ROUTES.CHATBOT);
    show(false);
  }
  const clickTeacher = () => {
    authUser.roles = [ROLES.ADMIN_DEMO, ROLES.TEACHER_DEMO];
    authUser.token = "token-albus-dumbledore";
    authUser.students = [{
      name: "Harry Potter",
      username: "harrypotter",
      token: "token-harry-potter",
      img: 'harry_potter.jpg',
    }]
    storeUser({...authUser});
    history.push(ROUTES.DASHBOARD);
    show(false);
  }

  const imgStyle = window.innerWidth < 520 ?
    { margin: 'auto', cursor: 'auto', padding: '16px', backgroundColor: 'white', borderRadius: '8px'} :
    { cursor: 'pointer', padding: '16px', backgroundColor: 'white', borderRadius: '8px' };
  
  if (visible) {
    return (
      <div style={{
        padding: '30px',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
      }}>
          <Card
            style={{ margin: '16px', maxWidth: '800px' }}
          >
            <Meta title="Améliorer sa syntaxe" />
            <div>
              <br />
              <p>Module 1 : Appréhender et manipuler intuitivement la structure syntaxique d’une phrase.</p>
              <p>L’application commence par proposer un test diagnostique, dont le résultat permet d’orienter vers un parcours personnalisé, avant de vérifier ce qui a été acquis lors d’un test final.</p>
            </div>
          </Card>
        <Row gutter={36} type='flex' justify='space-around' style={{ maxWidth: '800px', margin: 'auto' }}>
          <Col>
            <Card
              hoverable
              style={{ width: 320, paddingTop: '24px' }}
              cover={<div
                style={imgStyle}
                onClick={clickStudent}
                style={{ margin: 'auto',  backgroundImage: `url(${StudentImage})`, width: '300px', height:'300px', cursor: 'pointer' }}
              />}
            >
              <Meta title="Parcours élève" />
            </Card>
          </Col>
          <Col>
            <Card
              hoverable
              style={{ width: 320, paddingTop: '24px' }}
              cover={<div
                style={imgStyle}
                onClick={clickTeacher}
                style={{ margin: 'auto', backgroundImage: `url(${TeacherImage})`, width: '300px', height:'300px', cursor: 'pointer' }}
              />}
            >
              <Meta title="Espace enseignant" />
            </Card>
          </Col>
        </Row>

      </div>
    );
  } else if (!!authUser && !visible) {
    const redirectRoute = (authUser.roles.includes(ROLES.TEACHER_DEMO)) ? ROUTES.DASHBOARD : ROUTES.CHATBOT;
    return <Redirect to={redirectRoute}/>;
  }
};

export default withRouter(Splash);